import {
  Close,
  LargeArrowLeft,
  Minus,
  SvgProps,
  SmallArrowUp,
  ThumbsUp,
  TopCaret,
  Refresh,
  Plus,
  Checkmark,
  LargeArrowRight,
  Filter,
} from "./icons";
import { useChatClass } from "../../theme";
import { Container } from "./styled";

const SVG = {
  close: Close,
  "large-arrow-left": LargeArrowLeft,
  "large-arrow-right": LargeArrowRight,
  minus: Minus,
  "small-arrow-up": SmallArrowUp,
  "thumbs-up": ThumbsUp,
  "top-caret": TopCaret,
  refresh: Refresh,
  plus: Plus,
  checkmark: Checkmark,
  filter: Filter,
};

export interface IconProps extends SvgProps {
  /** The name of the SVG icon to be rendered */
  name: keyof typeof SVG;
  /** Size of icon SVG, in user coordinate system. Controls "height" and "width" together. */
  size: number;
  /** SVG path fill color */
  color?: string;
  /** Div container for SVG element */
  containerStyle?: React.CSSProperties;
}

interface IconComponent extends React.FC<IconProps> {
  /** Div container for icon  */
  Frame: typeof Container;
}

/** Div container + SVG icon.
 *
 * - Use `containerStyle` to modify CSS of container div.
 * - Use `color` to modify SVG path fill color.
 * - All other properties will be passed to the SVG element, not the container
 */
const Icon: IconComponent = ({
  name,
  size,
  color,
  containerStyle,
  ...props
}: IconProps) => {
  const chatClass = useChatClass();
  const Svg = SVG[name];

  let width = size;
  let height = size;

  if (name === "top-caret") {
    width = size * 2;
    height = size;
  }

  return (
    <Container style={containerStyle} className={chatClass("icon")}>
      <Svg height={height} width={width} color={color} {...props} />
    </Container>
  );
};

Icon.Frame = Container;

export { Icon };
